export type Expr =
  | { kind: "literal"; value: number | string | boolean | null }
  | { kind: "ref"; scope: RefScope; name: string }
  | { kind: "unary"; op: "-" | "!"; arg: Expr }
  | { kind: "binary"; op: BinaryOp; left: Expr; right: Expr }
  | { kind: "conditional"; test: Expr; then: Expr; else: Expr }
  | { kind: "call"; name: string; args: Expr[] };

export type RefScope = "answers" | "vars" | "hidden";
export type BinaryOp = "+" | "-" | "*" | "/" | "%" | "==" | "!=" | "<" | "<=" | ">" | ">=" | "&&" | "||";

export class ExpressionError extends Error {
  constructor(
    message: string,
    public readonly position?: number,
  ) {
    super(message);
    this.name = "ExpressionError";
  }
}
